module.exports = __webpack_public_path__ + "static/media/setor-bg.092bf5a7.svg";